// extracted by mini-css-extract-plugin
export default {"form-input":"formInput_form-input__U2t+L","label":"formInput_label__gGdk4","input":"formInput_input__OkuQJ"};